var API_URL = 'https://maps.googleapis.com/maps/api/js';
var CALLBACK_NAME = '__googleMapsApiOnLoadCallback';
var optionsKeys = ['channel', 'client', 'key', 'language', 'region', 'v'];
var promise = null;

module.exports = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  promise = promise || new Promise(function (resolve, reject) {
    // Reject the promise after a timeout
    var timeoutId = setTimeout(function () {
      window[CALLBACK_NAME] = function () {}; // Set the on load callback to a no-op


      reject(new Error('Could not load the Google Maps API'));
    }, options.timeout || 10000); // Hook up the on load callback

    window[CALLBACK_NAME] = function () {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
      }

      resolve(window.google.maps);
      delete window[CALLBACK_NAME];
    }; // Prepare the `script` tag to be inserted into the page


    var scriptElement = document.createElement('script');
    var params = ["callback=".concat(CALLBACK_NAME)];
    optionsKeys.forEach(function (key) {
      if (options[key]) {
        params.push("".concat(key, "=").concat(options[key]));
      }
    });

    if (options.libraries && options.libraries.length) {
      params.push("libraries=".concat(options.libraries.join(',')));
    }

    scriptElement.src = "".concat(options.apiUrl || API_URL, "?").concat(params.join('&')); // Insert the `script` tag

    document.body.appendChild(scriptElement);
  });
  return promise;
};